import { render, staticRenderFns } from "./inputs-grid.vue?vue&type=template&id=3cd95370"
import script from "./inputs-grid.vue?vue&type=script&lang=js"
export * from "./inputs-grid.vue?vue&type=script&lang=js"
import style0 from "./inputs-grid.vue?vue&type=style&index=0&id=3cd95370&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports